export default __webpack_public_path__ + "static/media/GE Digital.a2d8c306.png";